const createQueryKeys = (scope: string) => ({
  all: [{ scope }] as const,
  lists: () => [{ scope, entity: 'list' }] as const,
  list: (filters?: unknown, id?: string) =>
    [{ scope, entity: 'list', filters, id }] as const,
  details: () => [{ scope, entity: 'detail' }] as const,
  detail: (id: string) => [{ scope, entity: 'detail', id }] as const,
});

export const ORGANIZATION_QUERY_KEYS = {
  ...createQueryKeys('organizations'),
  organizationsOfMe: (includeNoShops = true) =>
    [
      {
        scope: 'organizations',
        entity: 'list',
        ...(includeNoShops && { filters: { is_include_no_shop: true } }),
      },
    ] as const,
};

export const ACCOUNT_QUERY_KEYS = createQueryKeys('accounts');

export const SHOP_QUERY_KEYS = createQueryKeys('shops');

export const SALE_AREA_QUERY_KEYS = createQueryKeys('sale-areas');

export const DRINK_MATERIAL_QUERY_KEYS = createQueryKeys('drink-material');

export const PRINTER_AND_FIXTURE_QUERY_KEYS = createQueryKeys(
  'printer-and-fixtures',
);

export const ORGANIZATION_SHOPS_QUERY_KEYS =
  createQueryKeys('organization-shop');

export const ORGANIZATION_ACCOUNTS_QUERY_KEYS = createQueryKeys(
  'organization-account',
);

export const SHOP_APPROVAL_REQUESTS_QUERY_KEYS = createQueryKeys(
  'shop-approval-requests',
);

export const BILLING_INFORMATION_QUERY_KEYS = createQueryKeys(
  'invoice-managements',
);

export const SALES_PERFORMANCE_QUERY_KEYS = createQueryKeys('sale-figures');

export const FISCAL_MONTHS_QUERY_KEYS = createQueryKeys('fiscal-months');

export const AMOUNT_ADJUSTMENT_QUERY_KEYS = createQueryKeys(
  'billing-adjustments',
);

export const SALES_FIGURE_SHOP_QUERY_KEYS =
  createQueryKeys('sale-figure-shops');

export const BANNERS_QUERY_KEYS = createQueryKeys('banners');

export const DRINKS_QUERY_KEYS = createQueryKeys('drinks');

export const SHOP_DRINKS_QUERY_KEYS = createQueryKeys('shop_drinks');

export const IP_LABEL_QUERY_KEY = createQueryKeys('label-sets');

export const TEMPLATES_QUERY_KEY = createQueryKeys('templates');

export const SNAP_LABEL_QUERY_KEY = createQueryKeys('snap-label');

export const LABEL_ORDER_QUERY_KEY = createQueryKeys('label-order');

export const FULL_IP_LABEL_QUERY_KEY = createQueryKeys('full-ips');

export const SNAP_DRINK_TEMPLATES_QUERY_KEY = createQueryKeys(
  'snap-drink-templates',
);

export const ACODE_UPDATE_QUERY_KEY = createQueryKeys('acode-update');
